'use strict';
(function () {
  angular.module('pentaApp').factory('chat.resource', service);

  service.$inject = ['resourceHelper.factory', 'Upload'];
  function service(resourceHelper, Upload) {
    var url = '/progressiveApp/api/chat'
    return resourceHelper.defaultResource(url, null, { model: 'chatLog' });
  }
})();